import { render, staticRenderFns } from "./SectionBoxFileManager.vue?vue&type=template&id=238f231a&"
import script from "./SectionBoxFileManager.vue?vue&type=script&lang=js&"
export * from "./SectionBoxFileManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports